import { strokeDasharray, arc } from '../IndicatorBase/util.js';
import { keyframes } from 'styled-components';
import { ANGLE_0, ANGLE_90, ANGLE_180, ANGLE_270, ANGLE_360 } from '../IndicatorBase/constants.js';
import { SDS_MOTION_EASING_EXIT, SDS_MOTION_EASING_ENTRY } from '@s-group/design-system-tokens/web/tokens/motion.es6.js';

// Keyframes are defined using keyframes function instead of tagged template
// literals, because Prettier fails to format their content properly:
// https://github.com/prettier/prettier/issues/11196
const entry = () => keyframes({
    '0%': {
        strokeDasharray: strokeDasharray(ANGLE_0),
    },
    '100%': {
        strokeDasharray: strokeDasharray(ANGLE_90),
    },
});
const loopStretch = () => keyframes({
    '0%': {
        strokeDasharray: strokeDasharray(ANGLE_90),
        strokeDashoffset: -arc(ANGLE_0),
        animationTimingFunction: `cubic-bezier(${SDS_MOTION_EASING_EXIT})`,
    },
    '25%': {
        strokeDasharray: strokeDasharray(ANGLE_180),
        strokeDashoffset: -arc(ANGLE_0),
        animationTimingFunction: `cubic-bezier(${SDS_MOTION_EASING_ENTRY})`,
    },
    '50%': {
        strokeDasharray: strokeDasharray(ANGLE_270),
        strokeDashoffset: -arc(ANGLE_90),
        animationTimingFunction: `cubic-bezier(${SDS_MOTION_EASING_EXIT})`,
    },
    '75%': {
        strokeDasharray: strokeDasharray(ANGLE_180),
        strokeDashoffset: -arc(ANGLE_180),
        animationTimingFunction: `cubic-bezier(${SDS_MOTION_EASING_ENTRY})`,
    },
    '100%': {
        strokeDasharray: strokeDasharray(ANGLE_90),
        strokeDashoffset: -arc(ANGLE_360),
        animationTimingFunction: `cubic-bezier(${SDS_MOTION_EASING_EXIT})`,
    },
});
const loopRotate = () => keyframes({
    '0%': {
        transform: 'translateX(0%)',
    },
    '100%': {
        transform: 'translateX(100%)',
    },
});

export { entry, loopRotate, loopStretch };
//# sourceMappingURL=bar.keyframes.js.map
